import { render, staticRenderFns } from "./LvLoadingCard.vue?vue&type=template&id=42c1070a"
import script from "./LvLoadingCard.vue?vue&type=script&lang=js"
export * from "./LvLoadingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports